export default __webpack_public_path__ + "static/media/640_dummy2016-zahnarzt01-de.9e0ae02e.png";